import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_CHECKOUT = `${URL_RETAILER_SCOPED}/checkout`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'checkout'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  checkout: URL_CHECKOUT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
